import React from 'react';
import { Grid } from '@material-ui/core';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { styles } from './styles';

import { BaseButton } from 'src/common/components/base-button';
import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';

interface ButtonProps {
  label: string;
}

type MenuButtonProps = ButtonProps & NCRBaseButtonProps;

interface MenuFooterProps {
  buttons: MenuButtonProps[];
  trainingModeActive: boolean;
}

const MenuFooter = ({ trainingModeActive, buttons }: MenuFooterProps): JSX.Element => {
  const classes = styles();
  const trainingModeClasses = trainingModeStyles();
  return (
    <Grid
      container
      className={` ${classes.menuBottomRowContainer} ${
        trainingModeActive ? trainingModeClasses.trainingModeBackground : ''
      } fullWidth`}
      justifyContent='space-between'
      wrap='nowrap'
    >
      {buttons.map(({ 'data-testid': testId, onClick, label, className, ...rest }) => {
        return (
          <Grid item key={testId} className={classes.buttonContainer}>
            <BaseButton
              className={className ? classes[className] : undefined}
              classes={{ startIcon: classes.buttonIcon }}
              onClick={onClick}
              data-testid={testId}
              {...rest}
            >
              <span className={classes.buttonLabel}>{label}</span>
            </BaseButton>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default MenuFooter;
